module.exports = __webpack_public_path__ + "img/banner2.48687061.png";